// import { searchDistricts } from '@/api/v1/device/companys'
import { storeBefore } from '../../api/product'
import { awards } from '../../api/product'
const state = {
  districts: [],
  currentCompetitionType: '', // 1-综合赛，2-企业命题赛
  competitionCategory: '', // 新增：参赛类别
  dictionary: null,
  awards: []
}

const mutations = {
  SET_AWARDS: (state, awards) => {
    state.awards = awards
  },
  SET_DICTIONARY: (state, dictionary) => {
    state.dictionary = dictionary
  },
  SET_DISTRICTS: (state, districts) => {
    state.districts = districts
  },
  SET_CURRENT_COMPETITION_TYPE: (state, type) => {
    state.currentCompetitionType = type
  },
  SET_COMPETITION_CATEGORY(state, category) {
    state.competitionCategory = category
  }
}

const actions = {
  getAwards({ commit, state }) {
    console.log('getAwards')
    awards().then(res => {
      commit('SET_AWARDS', res)
    })
  },
  getDistricts({ commit, state }) {
    storeBefore(state.currentCompetitionType).then(res => {
      console.log('res', res)

      console.log('2')
      res.managers = [{
        id: 0,
        lastname: '无',
        firstname: '',
        name: ''
      }].concat(res.managers)
      commit('SET_DICTIONARY', res)
    }).catch(res => {
      console.error(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
